"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mgrs = require("./transform_mgrs");
exports.mgrs = mgrs;
const egsa = require("./egsa");
exports.egsa = egsa;



//////////////////
// WEBPACK FOOTER
// ./node_modules/gs-geo/dist/index.js
// module id = 4
// module chunks = 0